<template>
<Layout heading-text="SysAdmin Members" v-if="type === 'admin'">
  <h1 class="text-center pb-0 text-xl font-bold text-blue-600 sm:text-left md:text-center lg:text-center xl:text-center"></h1>
  <div v-for="hardware1 in hardwares1" :key="hardware1.id"> 
    </div>
  <div id="Admins View"> 

    <div class="grid grid-cols-2" >
      
      <div ><BaseInput class="mt-2 pl-2 px-2" style="color: #C38437" label="Search Members" v-model="name" /></div>
      <div class="pt-10 hidden md:block">
   
  
        <button v-if="!mobileOpen1"
        type="button"
        v-on:click="addMember();"
        class="relative inline-flex items-center pl-4 px-5 py-4 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
         >
        <img class="h-6 w-6" src="../assets/add-friend.png" alt />
        <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
        <h1 class=tracking-wider >Add Member</h1>
        </a>
      </button>
       <button v-if="!mobileOpen1"
            type="button"
            v-on:click="getMembers(); "
            class="relative inline-flex items-center pl-4 px-5 py-4 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/refresh2.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Refresh Last 150</h1>
            </a>
       </button>
          <button v-if="!mobileOpen1"
            type="button"
            v-on:click="getAllMembers(); "
            class=" relative inline-flex items-center pl-4 px-5 py-4 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/member-card.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Load All Members</h1>
            </a>
       </button>
                 <button v-if="!mobileOpen1"
            type="button"
            v-on:click="getAllChildren(); "
            class=" relative inline-flex items-center pl-4 px-5 py-4 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/child.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Members & Children</h1>
            </a>
       </button>
                  <button v-if="!mobileOpen1"
            type="button"
            v-on:click="getNonMembers(); "
            class=" relative inline-flex items-center pl-4 px-5 py-4 pt-0 bg-white border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-yellow-600 focus:outline-none transition duration-150 ease-in-out"
            >
            <img class="h-6 w-6" src="../assets/nonmember1.png" alt />
            <a  class="absolute inset-0 z-6 px-2 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Non Members</h1>
            </a>
       </button>
        <li v-if="members.length" class="relative inline-flex items-center px-5 py-0 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out" >
            <export-excel 
              :data   = "members"
              :fields = "json_fields"
              worksheet = "GraceMembers"
              name    = "GraceMembers.xls">
              <img class="h-6 w-6" src="../assets/excel1.jpg">
              <a  class="absolute inset-0 z-6 px-4 pl-2 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
            <h1 class=tracking-wider >Down load</h1>
            </a>
          </export-excel>
          </li>
           
        
  
    </div>
          <div class="hidden md:block rounded-lg px-0 mx-2" >
        <div 
          class=" mx-auto py-0 px-0 sm:px-0 lg:py-0 lg:px-2 lg:flex lg:items-center lg:justify-between"
        >
            <h2
            class="text-lg sm:text-lg lg:text-xl leading-8 font-extrabold tracking-tight text-black  sm:leading-8"
          >
          Total  :
            <a style="color: #C38437"
              class="text-lg leading-8 font-extrabold tracking-tight sm:text-lg lg:text-xl sm:leading-8"
              ></a
              
            ><a class="text-yellow-600">{{members.length}}</a>
            
          
          </h2> 
        </div>
      </div>
         
    </div>
     <div v-if="mobileOpen1">
        <h1 class="block uppercase tracking-wide text-gray-700 text-lg font-thin mb-2 pt-6">START & END DATE</h1>
        <BaseInput label="" type="date" class=" bg-gray-200 rounded pl-2 px-2" placeholder="..." v-model="searchDate" />
          <BaseInput label="" type="date" style="background-color: #C38437" class=" rounded  pl-2 px-2" placeholder="..." v-model="endDate" />
          <div class="pt-2">
          <button
            type="button"
            v-on:click="getSermonDate(searchDate, endDate); toggleMobilemenu1();"
            class="inline-flex items-center px-2 py-0  hover:bg-yellow-500 border border-transparent text-sm leading-5 font-medium rounded-md text-white focus:outline-none focus:shadow-outline-indigo focus:border-yellow-500 active:bg-yellow-500 transition duration-150 ease-in-out"
              >
              
          <img class="h-12 w-auto" src="../assets/searchBible.png" alt="Workflow" />
        </button>
      </div>
      </div>
    <div v-if="!members.length" class="flex flex-col-2 pl-2">
          <img
            class="rounded-lg h-full"
            src="../assets/nomembers.png"
            alt=""
            />
          
          </div>
     
   
     <div >
      <div v-if="members.length" class="flex flex-col pt-2 hidden md:block">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-10">
        <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr>
                <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 No
                </th>
                <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                  Name
                </th>
                <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Married Status & Date
                </th>
                  <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Children
                </th>
                 <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Mobile No
                </th>
                  <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Baptized Grace
                </th>
                <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Baptism Date
                </th>
                
                <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Member Date
                </th>
                <th  class="px-1 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Member
                </th>
                <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">VIEW</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="member in members" :key="member.id">
                  <td class="px-2 py-0 whitespace-no-wrap border-b border-gray-200">
                  <div class="flex items-center">
                    <div class="ml-0">
                        <div class="text-base leading-5 font-medium  text-gray-900">#{{ member.memberNo }}</div>
                      <div class="text-base leading-5 font-medium text-red-600"></div>
                    </div>
                  </div>
                </td>
                <td class="px-2 py-0 whitespace-no-wrap border-b border-gray-200">
                  <div class="flex items-center">
                    <div class="ml-0">
                      <div class="text-base leading-5 font-medium text-black"> {{ member.firstName }} {{ member.lastName }}</div>
                      <div class="text-base leading-5 font-medium text-red-600"></div>
                    </div>
                  </div>
                </td>
                   <td class="px-2 py-1 whitespace-wrap border-b border-gray-200">
                  <div class="text-base leading-5 font-medium text-black"></div>
                     <div class="flex items-center">
                    <div class="ml-1">
                        <div class="text-base leading-5 font-medium text-yellow-600"><a class="text-black">Status :</a> {{ member.marriageStatus}}</div>
                        <div v-if="member.marriageDate" class="text-base leading-5 font-medium text-yellow-600"><a class="text-black">Married Date :</a> {{ new Date(member.marriageDate).toLocaleDateString()}}</div>
                         <div v-if="member.spouse != ''" class="text-base leading-5 font-medium text-yellow-600"><a class="text-black">Spouse :</a> {{ (member.spouse)}}</div>
                    </div>
                  </div>
                </td>
                    <td class="px-2 py-1 whitespace-wrap border-b border-gray-200">
                  <div class="text-base leading-5 font-medium text-black"></div>
                     <div class="flex items-center">
                    <div class="ml-0">
                        <div v-if="member.children >= '1'" class="text-base leading-5 font-medium text-red-400 px-5">{{ member.children}}</div>
                          <div v-if="member.children === '0'" class="text-base leading-5 font-medium text-black px-5">{{ member.children}}</div>
                    </div>
                  </div>
                </td>
                    <td class="px-2 py-1 whitespace-wrap border-b border-gray-200">
                  <div class="text-base leading-5 font-medium text-black"></div>
                     <div class="flex items-center">
                    <div class="ml-0">
                        <div class="text-base leading-5 font-medium text-black">{{ member.mobileNo}}</div>
                    </div>
                  </div>
                </td>
                  <td  class="px-10 py-0 whitespace-wrap border-b border-gray-200">
                    <div v-if="member.baptizedGrace === 'YES'" class="text-base leading-5 font-medium text-yellow-600">{{ member.baptizedGrace}}</div> 
                    <div v-if="member.baptizedGrace === 'NO'" class="text-base leading-5 font-medium text-red-500">{{ member.baptizedGrace}}</div> 
                     
                </td>
                <td  class="px-2 py-0 whitespace-wrap border-b border-gray-200">
                    <div v-if="member.baptismDate" class="text-base leading-5 font-medium text-yellow-600">{{ new Date(member.baptismDate).toLocaleDateString()}}</div> 
                     <div v-if="member.baptismDateElse" class="text-base leading-5 font-medium text-red-500">{{ new Date(member.baptismDateElse).toLocaleDateString()}}</div> 
                </td>
               
              
                 <td class="px-2 py-0 whitespace-wrap border-b border-gray-200">
                   <div v-if="member.membershipDate" class="text-base leading-5 font-medium  text-red-500">{{ new Date(member.membershipDate).toLocaleDateString() }}</div>  
                   <div v-if="!member.membershipDate" class="text-base leading-5 font-medium  text-red-500">Non Member</div> 
                </td>
                <td class="px-1 py-0 whitespace-wrap border-b border-gray-200">
                <span v-if="member.activeMember === 'YES'" class="px-3 inline-flex text-base leading-5 font-semibold rounded-full text-black bg-green-200">
                {{member.activeMember}}
              </span>
                 <span v-if="member.activeMember === 'NO'" class="px-3 inline-flex text-base leading-5 font-semibold rounded-full text-black bg-red-200">
                {{member.activeMember}}
              </span>
            </td>
                <td class="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-base leading-5 font-medium">
                  <router-link :to="{ name: 'adminmemberview', params: { id: member.id } }" class="text-indigo-600 hover:text-red-600"><img class="h-8 w-auto" src="../assets/member-card.png" alt="Workflow" /></router-link>
               </td> 
            </tr>
            </tbody>
          </table>
          <div >
          <!-- <button type="button" @click="selectemployee(-1)" class="btn btn-primary btn-lg pt-2 pl-2">Previous</button>
            <button type="button"  @click="selectemployee(1)" class="btn btn-secondary btn-lg pl-2">Next</button>-->
            </div>
        </div>
      </div>
    </div>
     <div v-if="members.length" class="flex flex-col pt-2 block md:hidden">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-10">
        <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr>
                <th class="px-2 py-0 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                 Member Info
                </th>
                <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">VIEW</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-for="member in members" :key="member.id">
                  <td class="px-2 py-0 whitespace-no-wrap border-b border-gray-200">
                  <div class="flex items-center">
                    <div class="ml-0">
                        <div class="text-base leading-5 font-medium  text-gray-900">Member : #{{ member.memberNo }}</div>
                         <div class="text-base leading-5 font-medium text-black">Name : {{ member.firstName }} {{ member.lastName }}</div>
                          <div class="text-base leading-5 font-medium text-black"><a class="text-black"><a class="text-black">Mobile : </a></a>{{ member.mobileNo}}</div>
                         <div class="text-base leading-5 font-medium text-yellow-600"><a class="text-black">Status : </a> {{ member.marriageStatus}}</div>
                        <div v-if="member.marriageDate" class="text-base leading-5 font-medium text-yellow-600"><a class="text-black">Married Date : </a> {{ new Date(member.marriageDate).toLocaleDateString()}}</div>
                            <div class="text-base leading-5 font-medium text-yellow-600"><a class="text-black">Baptism Date : </a> {{ new Date(member.baptismDate).toLocaleDateString()}}</div> 
                             <div class="text-base leading-5 font-medium  text-red-500"><a class="text-black">Membership Date : </a>{{ new Date(member.membershipDate).toLocaleDateString() }}</div>  
                            <span v-if="member.activeMember === 'YES'" class="px-1 inline-flex text-base leading-5 font-semibold rounded-full text-black bg-green-200">
                             Active Member : {{member.activeMember}}
                            </span>
                              <span v-if="member.activeMember === 'NO'" class="px-1 inline-flex text-base leading-5 font-semibold rounded-full text-black bg-red-200">
                              Active Member : {{member.activeMember}}
                            </span>
                      <div class="text-base leading-5 font-medium text-red-600"></div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-base leading-5 font-medium">
                  <router-link :to="{ name: 'adminmemberview', params: { id: member.id } }" class="text-indigo-600 hover:text-red-600"><img class="h-8 w-auto" src="../assets/view.png" alt="Workflow" /></router-link>
               </td> 
            </tr>
            </tbody>
          </table>
          <div >
          <!-- <button type="button" @click="selectemployee(-1)" class="btn btn-primary btn-lg pt-2 pl-2">Previous</button>
            <button type="button"  @click="selectemployee(1)" class="btn btn-secondary btn-lg pl-2">Next</button>-->
            </div>
        </div>
      </div>
    </div>
      </div>
    
    
   
      </div>
  </Layout>
</template>

<script>
//import Layout from './layouts/Main.vue'
import { mapGetters } from "vuex";
import BaseInput from "../components/BaseInput";
import Vue from 'vue'
import excel from 'vue-excel-export'

Vue.use(excel)

export default {
  name: 'searchmembers',
  components: { BaseInput},
  
  data() {
    return {
      members: [],
      entryType: "",
      startDate: "",
      endDate: "",
      mobileOpen: false,
      mobileOpen2: false,
      tab: "",
      mobileOpen1 : false,
      searchDate: "",
      sermonLink : "",
      name : "",
      tab1: "",
      date : new Date(Date.now()).toLocaleDateString(),
         json_fields: {
            'Active Member': 'activeMember',
            'Member No': 'memberNo',
            'First Name': 'firstName',
            'Last Name': 'lastName',
            'Spouse Name': 'spouse',
            'Children': 'children',
            'Children Names': 'childrenNames',
            'Birth Date': 'birthDate',
            'Address': 'address',
            'Email': 'emailAddress',
            'Mobile': 'mobileNo',
            'Other Tel': 'otherTel',
            'Marriage Status': 'marriageStatus',
            'Marriage Date': 'marriageDate',
            'Baptism Date' : 'baptismDate',
            'Baptism Date Else' : 'baptismDateElse',
            'Membership Date': 'membershipDate'
         }
        
      
        
      }
    },
    created(){
      this.type = this.currentUserData.userType;
      //this.email = this.currentUserData.email;
      //this.userStatus = this.currentUserData.status;
      //this.member = this.currentUserData.MainAdmin;
      if (this.type !== "admin") {
        this.$router.push({
        name: "Home",
        });
      }
      this.getMembers();
     // this.getManualNo();
     // this.getReopened();
  
    },
    computed: {
    ...mapGetters(["currentUserData"]),

    },
   watch: {
    name(name) {
      this.getMemberName(name.toLowerCase());
    },
  },
    methods: {
    getMembers() {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("members")
        .where("firstName", "!=", '')
        .orderBy("firstName", 'asc')
        .limit(150)
       
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.members = users;
      });
      //this.sermonLink = ""
      //this.name = ""
    },
      getAllMembers() {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("members")
        .where("membershipDate", ">=", '1900-01-01')
        .orderBy("membershipDate")
        
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.members = users;
      });
      //this.sermonLink = ""
      //this.name = ""
    },
          getAllChildren() {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("members")
        .where("children", ">=", '1')
        
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.members = users;
      });
      //this.sermonLink = ""
      //this.name = ""
    },
      getNonMembers() {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("members")
        .where("activeMember", "==", 'NO')
        
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.members = users;
      });
      //this.sermonLink = ""
      //this.name = ""
    },
    getMemberName(name) {
      const users = [];
      const pendingApprovalsRef = this.$db
        .collection("members")
        .where("search", "array-contains", name)
       
      pendingApprovalsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        this.members = users;
      });
    },
    clear(){
      this.searchDate = "",
      this.endDate = "",
      this.sermonLink = "",
      this.name = ""
    },
          async getCheckDoc(id) {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", id)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
      getSermonDate(searchDate, endDate) {
    const hardwares = [];
    this.$db
      .collection("sermons")
      .where("searchDate", ">=", searchDate)
      .where("searchDate", "<=", endDate)
      .orderBy('searchDate')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.sermons = hardwares;
      this.sermonLink = ""
      //this.sumTravis();
    },  
    getIncidents() {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("entryDate", ">=", "2024-01-01")
      //.where("ticketOwner", "==", 'travis@platinumpos.com')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      });
      this.incidents = hardwares;
    },
     goBack() {
      this.$router.go();
    },
    getIncidentsCurrent() {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("date", ">=", this.date)
      //.where("ticketOwner", "==", 'travis@platinumpos.com')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      });
      this.incidents = hardwares;
    },
    getDates(startDate, endDate) {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("entryDate", ">=", startDate)
      .where("entryDate", "<=", endDate)
      .orderBy("entryDate")
      //.where("ticketOwner", "==", 'travis@platinumpos.com')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      });
      this.incidents = hardwares;
    },

    setTab(tab) {
      this.tab = tab;
    },
    setTab1(tab1) {
      this.tab1 = tab1;
    },
       toggleMobilemenu1() {
      this.mobileOpen1 = !this.mobileOpen1;
    },
    getDates2() {
      const userData = this.$db
        .collection("incidents")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("entryDate", ">=", this.startDate)
        .where("entryDate", "<=", this.endDate)
        .orderBy("entryDate")
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.manual = data;
        });
      });
    },
    getManualNo() {
      const userData = this.$db
        .collection("manualID")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("active", "==",'yes')
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.manual = data;
        });
      });
    },
    getClientTypes(calls) {
      return calls.map((call) => {
        return {
          value: `${call.admin}`,
          label: `${call.admin}`,
        };
      });
    },
    getEntryTypes(entryType) {
    const hardwares = [];
    this.$db
      .collection("incidents")
      .where("entryType", "==", entryType)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.incidents = hardwares;
    },
    getSearch(name) {
    const hardwares = [];
    this.$db
      .collection("manuals")
      .where("search", "array-contains", name)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.hardwares = hardwares;
    },
    getManualSearch(mansearch) {
    const hardwares = [];
    this.$db
      .collection("manuals")
      .where("manualNo", "==", mansearch)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          hardwares.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      })
      ;
      this.hardwares = hardwares;
    },
    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
      },
      toggleMobilemenu2() {
      this.mobileOpen2 = !this.mobileOpen2;
      },
    addIncident() {
      this.$router.push({
        name: "addsermon",
      });
    },
      addMember() {
      this.$router.push({
        name: "adminaddmember",
      });
    },
  
    }
}


</script>